<template>
  <div class="type-p">
    <Breadcrumb></Breadcrumb>
    <div class="form-body">
      <el-form label-width="80px" :model="queryParams" ref="queryForm">
        <el-row :gutter="24">
          <el-col :span="8">
            <el-form-item label="分类名称：" prop="typeName">
              <el-input
                size="small"
                v-model="queryParams.typeName"
                placeholder="请输入分类名称"
                clearable
              />
            </el-form-item>
          </el-col>

          <el-col :span="8">
            <el-form-item label="状态：" prop="status">
              <el-select clearable 
                size="small"
                v-model="queryParams.status"
                placeholder="分类状态"
              >
                <template
                  v-for="(value, key) in dictData['sys_normal_disable']"
                >
                  <el-option :key="key" :label="value.label" :value="value.value"></el-option>
                </template>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item style="text-align:right;">
              <el-button size="small" @click="loadData" type="primary"
                >搜索</el-button
              >
              <el-button size="small" @click="resetQuery">重置</el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div class="table-body">
      <el-row :gutter="24">
        <el-col :span="24">
          <el-button
            size="small"
            type="primary"
            icon="el-icon-plus"
            @click="handleAdd"
            >新增
          </el-button>
        </el-col>
      </el-row>
      <!-- <pagination
        class="bottom-sticky"
        :total="total"
        :page.sync="queryParams.pageNum"
        :limit.sync="queryParams.pageSize"
        @pagination="loadData"
        :layout="'slot, total, sizes, prev, pager, next, jumper'"
      >
        <span style="float:left;">
          <el-button type="primary" icon="el-icon-plus" @click="handleAdd"
            >新增
          </el-button>
        </span>
      </pagination> -->
      <el-table
        :data="tableData"
        row-key="typeId"
        lazy
        :tree-props="{ children: 'childrenTree' }"
      >
        <el-table-column label="分类名称" prop="typeName"></el-table-column>
        <el-table-column label="英文名称" prop="engTypeName"> </el-table-column>
        <el-table-column label="排序" prop="orderNum"> </el-table-column>
        <el-table-column label="状态">
          <template slot-scope="scope">
            <span>{{ dictMap["sys_normal_disable"][scope.row.status] }}</span>
          </template>
        </el-table-column>
        <el-table-column label="创建时间" prop="createTime"></el-table-column>
        <el-table-column label="更新时间" prop="updateTime"></el-table-column>
        <el-table-column label="操作" prop="oper" fixed="right" width="250">
          <template slot-scope="scope">
            <el-button type="text" size="mini" @click="handleUpdate(scope.row)"
              >修改</el-button
            >
            <el-button size="mini" type="text" @click="handleDelete(scope.row)"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <!-- <pagination
        class="bottom-sticky"
        v-show="total > 0"
        :total="total"
        :page.sync="queryParams.pageNum"
        :limit.sync="queryParams.pageSize"
        @pagination="loadData"
      />-->
    </div>

    <el-dialog :close-on-click-modal="false"  
      class="type-edit-dialog"
      :dialogTitle="dialogTitle"
      :visible.sync="dialogVisible"
      width="600px"
    >
      <el-form
        ref="form"
        :model="form"
        label-width="80px"
        :rules="rules"
        style="margin: 15px"
      >
        <el-row>
          <el-col :span="24">
            <el-form-item label="上级分类" prop="pTypeId" class="tree-sel">
              <treeselect
                class="type-sel"
                v-model="form.pTypeId"
                :options="typeOptions"
                :normalizer="normalizer"
                :show-count="true"
                placeholder="选择上级分类"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="分类名称" prop="typeName">
              <el-input
                size="small"
                v-model="form.typeName"
                placeholder="请输入分类名称"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="英文名称" prop="engTypeName">
              <el-input
                size="small"
                v-model="form.engTypeName"
                placeholder="请输入英文名称"
                maxlength="20"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="显示排序" prop="orderNum">
              <el-input-number
                size="small"
                v-model="form.orderNum"
                controls-position="right"
                :min="0"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="分类状态">
              <el-radio-group v-model="form.status">
                <template
                  v-for="(value, key) in dictData['sys_normal_disable']"
                >
                  <el-radio :label="value.value" :key="value.value"> {{ value.label }}</el-radio>
                </template>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="cancel">取 消</el-button>
        <el-button size="small" type="primary" @click="submitForm"
          >确 定</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters } from "vuex"
import Breadcrumb from "@/components/common/Breadcrumb"
import {
  loadTypeData,
  getTypeInfo,
  getTypeTree,
  addType,
  updateType,
  deleteType,
  getTypeTreeList
} from "@/api/sysSupport/category"
import Treeselect from "@riophae/vue-treeselect"
import "@riophae/vue-treeselect/dist/vue-treeselect.css"

export default {
  name: "cpType",
  components: { Breadcrumb, Treeselect },
  data() {
    return {
      queryParams: {
        typeName: undefined,
        status: undefined,
        pageSize: 30,
        pageNum: 1,
      },
      total: 0,
      loading: false,
      tableData: [],
      // 编辑表单
      dialogTitle: "",
      dialogVisible: false,
      form: {
        typeId: undefined,
        typeName: undefined,
        engTypeName: undefined,
        orderNum: undefined,
        status: "1",
      }, // 表单校验
      rules: {
        typeName: [
          { required: true, message: "分类名称不能为空", trigger: "blur" },
        ],
        engTypeName: [
          { required: true, message: "英文名称不能为空", trigger: "blur" },
        ],
        orderNum: [
          { required: true, message: "分类顺序不能为空", trigger: "blur" },
        ],
      },
      typeOptions: [], //分类选择树
    }
  },
  computed: {
    ...mapGetters(["dictData", "dictMap", "nginx"]),
  },
  created() {
    this.loadData()
  },
  methods: {
    loadData() {
      this.startLoading()
      const params = this.queryParams
      getTypeTreeList(params)
        .then((response) => {
          // response.data.map((item) => {
          //   item.hasChildren = item.isLeaf === "0" ? true : false
          // })
          this.tableData = response.data
          this.endLoading()
        })
        .catch((err) => {
          this.endLoading()
        })
    },
    resetQuery() {
      this.$refs["queryForm"].resetFields()
    },

    // 编辑的表单重置
    reset() {
      this.form = {
        typeId: undefined,
        pTypeId: 0,
        typeName: undefined,
        engTypeName: undefined,
        orderNum: undefined,
        status: "1",
      }
      this.resetForm("form")
    },
    // 新增
    handleAdd() {
      this.reset()
      this.getTreeSelect()
      this.dialogVisible = true
      this.dialogTitle = "添加分类"
    },
    // 修改
    handleUpdate(row) {
      this.reset()
      this.getTreeSelect()
      this.form = JSON.parse(JSON.stringify(row))
      this.dialogVisible = true
      this.dialogTitle = "修改分类"
    },
    handleDelete(row) {
      this.$confirm("确定要删除分类「" + row.typeName + "」吗？", "警告", {
        cancelButtonText: "取消",
        confirmButtonText: "确定",
        type: "warning",
      })
        .then(() => {
          return deleteType(row.typeId)
        })
        .then(() => {
          this.loadData()
          this.$message.success("删除成功")
        })
        .catch((err) => {})
    },
    // 提交保存
    submitForm() {
      this.$refs["form"].validate((valid) => {
        if (valid) {
          console.log(this.form)
          if (this.form.typeId != undefined) {
            updateType(this.form).then((response) => {
              if (response.code === 200) {
                this.msgSuccess("修改成功")
                this.dialogVisible = false
                this.loadData()
              }
            })
          } else {
            addType(this.form).then((response) => {
              if (response.code === 200) {
                this.msgSuccess("新增成功")
                this.dialogVisible = false
                this.loadData()
              }
            })
          }
        }
      })
    },
    cancel() {
      this.dialogVisible = false
      this.reset()
    },
    // 分类树获取
    getTreeSelect() {
      this.typeOptions = []
      getTypeTree().then((response) => {
        let type = { typeId: 0, typeName: "主类目", childrenTree: [] }
        type.childrenTree = response.data
        this.typeOptions.push(type)
      })
    },
    /** 转换分类数据结构 */
    normalizer(node) {
      if (node.childrenTree && !node.childrenTree.length) {
        delete node.childrenTree
      }
      return {
        id: node.typeId,
        label: node.typeName,
        children: node.childrenTree,
      }
    },
  },
}
</script>
